export class DirectoryEntityRecord {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "entityId",
            "baseName": "entityId",
            "type": "string",
            "format": ""
        },
        {
            "name": "entityType",
            "baseName": "entityType",
            "type": "DirectoryEntityType",
            "format": ""
        },
        {
            "name": "email",
            "baseName": "email",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "resourceId",
            "baseName": "resourceId",
            "type": "string",
            "format": ""
        },
        {
            "name": "snapshotId",
            "baseName": "snapshotId",
            "type": "string",
            "format": ""
        },
        {
            "name": "enabled",
            "baseName": "enabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "applicationSummary",
            "baseName": "applicationSummary",
            "type": "DirectoryApplicationSummary",
            "format": ""
        },
        {
            "name": "roleAssignmentSummary",
            "baseName": "roleAssignmentSummary",
            "type": "DirectoryRoleAssignmentSummary",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DirectoryEntityRecord.attributeTypeMap;
    }
    constructor() {
    }
}
